const directive = {
  inserted(el) {
    el.focus();
  }
};
export {
  directive as default,
  directive
};
